import { customAxios } from '../../common/customAxios';
import { myOwnTractorsApiUrl } from '../queries/getMyOwnTractors';

export interface IMyOwnTractorsReqBody {
  brandId?: string;
  model?: string;
  engineOutputInPs?: number;
  manufacturedYear?: number;
  operationTime?: number;
  marketPrice?: number | null;
  isPokeEnabled?: boolean;
}

interface patchMyOwnTractorsParams {
  ownTractorId: string;
  reqBody: IMyOwnTractorsReqBody;
}

export const patchMyOwnTractors = ({ ownTractorId, reqBody }: patchMyOwnTractorsParams): Promise<void> => {
  return customAxios.patch(`${myOwnTractorsApiUrl}/${ownTractorId}`, reqBody);
};
